export const replaceYearPlaceholder = (text: string, year: number): string =>
  text.split('{year}').join(String(year));
